import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import cx from 'classnames';
import { useDesignTokens, renderInlineCssVars } from '@sas/nova-commons/theme';
import cn from './StackLink.css.json';
import './StackLink.css';
export const StackLink = forwardRef((props, ref) => {
    const dt = useDesignTokens();
    return (_jsx("div", Object.assign({ ref: ref, className: cn.stackLink, style: renderInlineCssVars(StackLinkTokens(props.selected, dt), 'stack-link'), onClick: () => props.onClick && props.onClick(), "data-testid": props.testId, tabIndex: props.tabIndex, "aria-selected": props.selected, role: "tab" }, { children: _jsx("span", Object.assign({ className: cx(cn.stackLinkText, !props.wrapText && cn.stackLinkNoWrap) }, { children: props.label })) })));
});
function StackLinkTokens(selected, dt) {
    return {
        fg: selected ? dt.c.primary : dt.reportTokens.stateStandardContent.normal.fg,
        'text-decoration': selected ? 'none' : 'underline',
        cursor: selected ? 'default' : 'pointer',
    };
}
